import React, { useState } from 'react'
import { Flex, Input } from '@chakra-ui/react'
import Icon from '../Icon';
import {AutoResizeTextarea} from "../AutoResizeTextarea";

type InlineEditableFieldProps = {
  value: string
  canEdit: boolean
  isMultiline?: boolean
  onSave: (value: string) => void
  renderDisplay: (value: string) => React.ReactNode
}

export function InlineEditableField({
  value,
  canEdit,
  isMultiline,
  onSave,
  renderDisplay,
}: InlineEditableFieldProps) {
  const [isEditing, setIsEditing] = useState(false)
  const [draft, setDraft] = useState(value)

  const startEdit = () => {
    setDraft(value)
    setIsEditing(true)
  }

  const save = () => {
    if (draft !== value) {
      onSave(draft)
    }
    setIsEditing(false)
  }

  const cancel = () => {
    setDraft(value)
    setIsEditing(false)
  }

  return <Flex align="center" gap="0.5rem">
    <Flex flex="1" minW={0}>
      {isEditing ? (
        isMultiline ? (
          <AutoResizeTextarea
            value={draft}
            onChange={setDraft}
          />
        ) : (
          <Input
            width="100%"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
          />
        )
      ) : (
        renderDisplay(value)
      )}
    </Flex>

    {canEdit && !isEditing && (
      <Flex onClick={startEdit}>
        <Icon iconName="fi fi-rr-edit" style={{
          color: '#2c5aa0',
          fontSize: '16px',
        }} />
      </Flex>
    )}

    {isEditing && (
      <>
        <Flex onClick={save}>
          <Icon iconName="fi fi-rr-check" style={{
            color: '#2c5aa0',
            fontSize: '16px',
          }} />
        </Flex>
        <Flex onClick={cancel}>
          <Icon iconName="fi fi-rr-cross-small" style={{
            color: '#666',
            fontSize: '20px',
          }} />
        </Flex>
      </>
    )}
  </Flex>;
}
